import { Shield, MapPin, Wrench, Paintbrush, Wind, Gem } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useInView } from "@/hooks/useInView";

const FeaturesSection = () => {
  const { t, lang } = useI18n();
  const [headerRef, headerInView] = useInView();
  const [gridRef, gridInView] = useInView();

  const features = [
    { icon: Shield, title: t("features.f1.title"), description: t("features.f1.desc") },
    { icon: MapPin, title: t("features.f2.title"), description: t("features.f2.desc") },
    { icon: Wrench, title: t("features.f3.title"), description: t("features.f3.desc") },
    { icon: Paintbrush, title: t("features.f4.title"), description: t("features.f4.desc") },
    { icon: Wind, title: t("features.f5.title"), description: t("features.f5.desc") },
    { icon: Gem, title: t("features.f6.title"), description: t("features.f6.desc") },
  ];

  return (
    <section id="features" className="py-16 md:py-24 bg-muted/30">
      <div className="container mx-auto px-6">
        <div
          ref={headerRef}
          className={`text-center mb-16 anim-fade-up ${headerInView ? "in-view" : ""}`}
        >
          <span className={`text-muted-foreground text-sm font-bold ${lang === "en" ? "tracking-widest" : ""}`}>{t("features.label")}</span>
          <h2 className={`text-4xl md:text-5xl font-black text-foreground mt-3 ${lang === "en" ? "font-houstiq" : ""}`}>{t("features.title")}</h2>
          <div className="w-20 h-1 bg-cream mx-auto mt-4 rounded-full" />
        </div>

        <div ref={gridRef} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className={`bg-card p-8 rounded-2xl border border-border hover:border-cream/30 transition-all duration-500 group hover:shadow-xl anim-fade-up ${gridInView ? "in-view" : ""}`}
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className="w-14 h-14 bg-cream rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <feature.icon className="text-navy" size={26} />
              </div>
              <h3 className="text-xl font-bold text-card-foreground mb-3">{feature.title}</h3>
              <p className="text-muted-foreground leading-relaxed text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
